import React from 'react';
import { useTheme } from '@flowcore-water/ui';

/**
 * Water Well Technician Training — placeholder page.
 * Linked from the sidebar directly under Dashboard (instructor/admin/outside_observer).
 * Content to be added.
 */
export const WaterWellTechTraining: React.FC = () => {
  const { t } = useTheme();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold" style={{ color: t.textPrimary }}>
          Water Well Technician Training
        </h1>
        <p className="mt-2" style={{ color: t.textSecondary }}>
          Training resources for water well technicians.
        </p>
      </div>

      <div
        className="rounded-lg p-8 text-center"
        style={{ background: t.cardBg, border: `1px solid ${t.border}` }}
      >
        <p style={{ color: t.textMuted }}>Content coming soon.</p>
      </div>
    </div>
  );
};
